import React, { useRef, useState, useEffect } from "react";
import { Layer, Stage, Text } from "react-konva";
import useResizeObserver from "use-resize-observer";
import styled from "styled-components";
import { colorAttentionBlue10, colorBrandRhumbixBlack, colorFunctionalGray60, colorFunctionalWhite, spacingS, } from "@rhumbix/rmbx_design_system_design_tokens";
import { SigStage, SignatureInput, FormInput } from "./shared-styled-components";
export const TypeToSign = (props) => {
    const { stageHeight, signatureBox, name, onTextChange, addSig, sigHtmlName, hasMixedValues, inputRef } = props;
    const { ref: wrapperRef, width } = useResizeObserver();
    const maxFontSize = 48;
    const minFontSize = 24;
    const textNode = useRef(null);
    const placeholder = "Enter full name";
    const [stageWidth, setStageWidth] = useState(width);
    const [fontSize, setFontSize] = useState(maxFontSize);
    const fontIncrement = 12;
    useEffect(() => {
        /**
         * We want to adjust the font size and stage width based on the size of the entered signature
         * We based the stage width on a rough calculation that the font Satisfy is usually twice as tall
         * as it is wide - so we set the stage width to be the font size/2 based on the number of chars in the name
         * If the width of the typed characters is too wide, we scale down the font.
         * If the name is shortened after being sized down, bump the fontSize back up
         */
        if (!width)
            return;
        const nameLength = name.length + 2;
        let newWidth = (nameLength * fontSize) / 2;
        let sizeIncrement = 0; //if we need to adjust the font size - we will adjust this
        if (newWidth < width && fontSize < maxFontSize && (nameLength * (fontSize + fontIncrement)) / 2 < width) {
            // try to size things back up if they are deleting characters and the new width is within the stage
            sizeIncrement = fontIncrement;
            newWidth = (nameLength * (fontSize + fontIncrement)) / 2;
        }
        else if (newWidth > width && fontSize > minFontSize) {
            // try to size things down to fit them in the given width
            sizeIncrement = -fontIncrement;
            newWidth = (nameLength * (fontSize - fontIncrement)) / 2;
        }
        setFontSize(fontSize + sizeIncrement);
        setStageWidth(Math.min(newWidth, width));
    }, [name]);
    /**
     * The text for the signature is fed in from the parent via a name prop
     * We then extract the signatureBox content as an image
     * If text exceeds the width, the text will wrap to a second line and re-center vertically
     */
    return (React.createElement(SigStage, { ref: wrapperRef },
        React.createElement(Stage, { width: stageWidth, height: stageHeight },
            React.createElement(Layer, { ref: signatureBox },
                React.createElement(Text, { text: name, fontFamily: "Satisfy", fontSize: fontSize, align: "left", width: stageWidth, lineHeight: 1, verticalAlign: "middle", height: stageHeight, offsetX: -16, padding: 24, fill: name !== placeholder ? colorBrandRhumbixBlack : colorFunctionalGray60, ref: textNode, wrap: "none" }))),
        React.createElement(SignatureInput, null,
            React.createElement(ScriptSignatureInput, { hasMixedValues: !!hasMixedValues, ref: inputRef, value: name, name: sigHtmlName, onChange: evt => onTextChange(evt), placeholder: hasMixedValues ? "Multiple Values" : "Enter full name", onBlur: addSig, autoComplete: "off", style: { fontSize: fontSize + "px" } }))));
};
export default TypeToSign;
const ScriptSignatureInput = styled(FormInput) `
    font-family: "Satisfy", cursive;
    height: 200px;
    color: ${colorBrandRhumbixBlack};
    text-align: left;
    line-height: 1;
    border: 0;
    margin-bottom: 0;
    box-shadow: none;
    text-indent: calc(${spacingS} * 2);
    background-color: ${props => (props.hasMixedValues ? colorAttentionBlue10 : colorFunctionalWhite)};
`;
